import './App.css';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import * as Sentry from '@sentry/browser';
import ls from 'local-storage';
import React, { useEffect } from 'react';
import { isMobile } from 'react-device-detect';
import { Provider } from 'react-redux';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import AppWrapper from '@/AppWrapper';
import PrivateRoute from '@/components/private-route';
import firebaseApp from '@/config/firebase.config';
// import Notifications from '@/pages/Notifications';
import Error404 from '@/pages/404';
import ActionPage from '@/pages/Actions';
import Login from '@/pages/Auth/Login';
import BrandEditor from '@/pages/brands/editor';
// import BrandDashboard from '@/pages/BrandDashboard';
import BrandManager from '@/pages/brands/manager';
// import BrandClaimManager from '@/pages/BrandClaimManager';
import CigarDashboard from '@/pages/cigars/dashboard';
import CigarEditor from '@/pages/cigars/editor';
import CigarManager from '@/pages/cigars/manager';
import CigarMatchManager from '@/pages/cigars/matches';
import CigarBandRecognition from '@/pages/cigars/recognition/manager';
import VitolaManager from '@/pages/cigars/vitolas/manager';
import DrinkManager from '@/pages/drink_pairings/manager';
import EventManager from '@/pages/events/manager';
import GroupManager from '@/pages/groups/manager';
import Settings from '@/pages/settings';
import Roles from '@/pages/settings/roles';
import RoleDetails from '@/pages/settings/roles/editor';
import Users from '@/pages/settings/users';
import AbandonedCarts from '@/pages/shop/carts/abandoned';
import PaymentGatewayConfig from '@/pages/shop/config/payment_gateways';
import ShippingConfig from '@/pages/shop/config/shipping';
import TaxConfig from '@/pages/shop/config/taxes';
import Discounts from '@/pages/shop/discounts';
import ProductEditor from '@/pages/shop/editor';
// import VenueClaimManager from '@/pages/VenueClaimManager';
// import ShopDashboard from '@/pages/ShopDashboard';
import ProductManager from '@/pages/shop/manager';
import OrderManager from '@/pages/shop/orders';
import UserManager from '@/pages/users/manager';
import VenueEditor from '@/pages/venues/editor';
// import VenueDashboard from '@/pages/VenueDashboard';
import VenueManager from '@/pages/venues/manager';
import PendingVenueManager from '@/pages/venues/pending';
import { UserStore } from '@/stores';

import store from './store';

const theme = createTheme({
  palette: {
    primary: {
      main: '#212121',
    },
    secondary: {
      // light: will be calculated from palette.secondary.main,
      main: 'rgb(211, 169, 102)',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#212121',
    },
    // @ts-ignore - this is okay, it creates a new palette named "danger"
    danger: {
      main: '#ff4700',
    },
    error: {
      main: '#ff4700',
    },
  },
});

function App() {
  useEffect(() => {
    const unsubscribe = firebaseApp.auth().onAuthStateChanged(async (user) => {
      if (user) {
        UserStore.update((s) => {
          s.firebaseUser = user;
          s.authenticated = true;
        });
        console.log('User is logged in!');
        Sentry.setUser({
          email: user.email,
        });
        await user.getIdToken().then((data) => {
          ls('boxpressd_admin_token_id', data);
        });
      }
    });
    return () => unsubscribe();
  }, []);

  return (
    <Provider store={store}>
      <ThemeProvider theme={theme}>
        <BrowserRouter basename="/">
          <Routes>
            {/* FIXME Enable the user to set the default route? Or reload to last used route? */}
            <Route
              path={`${process.env.PUBLIC_URL}/`}
              element={
                <Navigate
                  to={isMobile ? '/cigars/matches' : '/cigars/manager'}
                  replace
                />
              }
            />

            {/* Public routes */}
            <Route
              path={`${process.env.PUBLIC_URL}/login`}
              element={<Login />}
            />
            {/* <Route */}
            {/*  path={`${process.env.PUBLIC_URL}/pages/forget-password`} */}
            {/*  element={<ForgetPassword />} */}
            {/* /> */}
            {/* <Route */}
            {/*  path={`${process.env.PUBLIC_URL}/pages/reset-password`} */}
            {/*  element={<ResetPassword />} */}
            {/* /> */}

            {/* Private routes */}
            <Route element={<AppWrapper />}>
              {/*  <Route */}
              {/*    path={`${process.env.PUBLIC_URL}/cigars/dashboard`} */}
              {/*    element={ */}
              {/*      <PrivateRoute> */}
              {/*        <CigarDashboard /> */}
              {/*      </PrivateRoute> */}
              {/*    } */}
              {/*  /> */}
              <Route
                path={`${process.env.PUBLIC_URL}/cigars/dashboard`}
                element={
                  <PrivateRoute>
                    <CigarDashboard />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/cigars/manager`}
                element={
                  <PrivateRoute>
                    <CigarManager />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/cigars/vitolas/manager`}
                element={
                  <PrivateRoute>
                    <VitolaManager />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/cigars/editor/:id`}
                element={
                  <PrivateRoute>
                    <CigarEditor />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/targets/manager`}
                element={
                  <PrivateRoute>
                    <CigarBandRecognition />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/drink-pairings/manager`}
                element={
                  <PrivateRoute>
                    <DrinkManager />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/cigars/matches`}
                element={
                  <PrivateRoute>
                    <CigarMatchManager />
                  </PrivateRoute>
                }
              />
              {/*  <Route */}
              {/*    path={`${process.env.PUBLIC_URL}/brands/dashboard`} */}
              {/*    element={ */}
              {/*      <PrivateRoute> */}
              {/*        <BrandDashboard /> */}
              {/*      </PrivateRoute> */}
              {/*    } */}
              {/*  /> */}
              <Route
                path={`${process.env.PUBLIC_URL}/brands/manager`}
                element={
                  <PrivateRoute>
                    {/* @ts-ignore FIXME Convert this to a functional component */}
                    <BrandManager />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/brands/editor/:id`}
                element={
                  <PrivateRoute>
                    <BrandEditor />
                  </PrivateRoute>
                }
              />
              {/*  <Route */}
              {/*    path={`${process.env.PUBLIC_URL}/brands/claims`} */}
              {/*    element={ */}
              {/*      <PrivateRoute> */}
              {/*        <BrandClaimManager /> */}
              {/*      </PrivateRoute> */}
              {/*    } */}
              {/*  /> */}
              <Route
                path={`${process.env.PUBLIC_URL}/groups/manager`}
                element={
                  <PrivateRoute>
                    {/* @ts-ignore FIXME Convert this to a functional component */}
                    <GroupManager />
                  </PrivateRoute>
                }
              />
              {/*  <Route */}
              {/*    path={`${process.env.PUBLIC_URL}/venues/dashboard`} */}
              {/*    element={ */}
              {/*      <PrivateRoute> */}
              {/*        <VenueDashboard /> */}
              {/*      </PrivateRoute> */}
              {/*    } */}
              {/*  /> */}
              <Route
                path={`${process.env.PUBLIC_URL}/venues/manager`}
                element={
                  <PrivateRoute>
                    <VenueManager />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/venues/editor/:id`}
                element={
                  <PrivateRoute>
                    <VenueEditor />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/venues/pending`}
                element={
                  <PrivateRoute>
                    <PendingVenueManager />
                  </PrivateRoute>
                }
              />
              {/*  <Route */}
              {/*    path={`${process.env.PUBLIC_URL}/venues/claims`} */}
              {/*    element={ */}
              {/*      <PrivateRoute> */}
              {/*        <VenueClaimManager /> */}
              {/*      </PrivateRoute> */}
              {/*    } */}
              {/*  /> */}
              {/*  <Route */}
              {/*    path={`${process.env.PUBLIC_URL}/shop/dashboard`} */}
              {/*    element={ */}
              {/*      <PrivateRoute> */}
              {/*        <ShopDashboard /> */}
              {/*      </PrivateRoute> */}
              {/*    } */}
              {/*  /> */}
              <Route
                path={`${process.env.PUBLIC_URL}/shop/manager`}
                element={
                  <PrivateRoute>
                    <ProductManager />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/shop/editor/:id`}
                element={
                  <PrivateRoute>
                    <ProductEditor />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/shop/carts/abandoned`}
                element={
                  <PrivateRoute>
                    <AbandonedCarts />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/shop/orders`}
                element={
                  <PrivateRoute>
                    <OrderManager />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/shop/discounts`}
                element={
                  <PrivateRoute>
                    <Discounts />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/shop/config/payment-gateways`}
                element={
                  <PrivateRoute>
                    <PaymentGatewayConfig />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/shop/config/taxes`}
                element={
                  <PrivateRoute>
                    <TaxConfig />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/shop/config/shipping`}
                element={
                  <PrivateRoute>
                    <ShippingConfig />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/events/manager`}
                element={
                  <PrivateRoute>
                    {/* @ts-ignore FIXME Convert this to a functional component */}
                    <EventManager />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/actions`}
                element={
                  <PrivateRoute>
                    <ActionPage />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/users/manager`}
                element={
                  <PrivateRoute>
                    <UserManager />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/settings`}
                element={
                  <PrivateRoute>
                    <Settings />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/settings/roles`}
                element={
                  <PrivateRoute>
                    <Roles />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/settings/roles/:id`}
                element={
                  <PrivateRoute>
                    <RoleDetails />
                  </PrivateRoute>
                }
              />
              <Route
                path={`${process.env.PUBLIC_URL}/settings/users`}
                element={
                  <PrivateRoute>
                    <Users />
                  </PrivateRoute>
                }
              />
              {/*  <Route */}
              {/*    path={`${process.env.PUBLIC_URL}/notifications`} */}
              {/*    element={ */}
              {/*      <PrivateRoute> */}
              {/*        <Notifications /> */}
              {/*      </PrivateRoute> */}
              {/*    } */}
              {/*  /> */}
              <Route path="*" element={<Error404 />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </ThemeProvider>
    </Provider>
  );
}

export default App;
